import { liveQuery } from 'dexie'
import { useEffect, useState } from 'react'

export interface LiveResult<T> {
  data: T | undefined
  loading: boolean
  error: unknown
}

/**
 * Una consulta a la base de datos que se vuelve a ejecutar sola cada vez que cambian los datos
 * que lee (liveQuery de Dexie). Mientras carga por primera vez, `data` es `undefined`.
 */
export function useLive<T>(query: () => Promise<T>, deps: readonly unknown[]): LiveResult<T> {
  const [state, setState] = useState<LiveResult<T>>({ data: undefined, loading: true, error: null })
  useEffect(() => {
    const subscription = liveQuery(query).subscribe({
      next: (data) => setState({ data, loading: false, error: null }),
      error: (error: unknown) => setState({ data: undefined, loading: false, error }),
    })
    return () => subscription.unsubscribe()
    // La consulta cambia en cada render; lo que decide cuándo repetirla son `deps`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
  return state
}
